/**
 * Cores derivadas da primária da empresa para heros (Editorial, Luxo).
 * Mantém fallbacks alinhados ao tema global (--primary-color).
 */

const FALLBACK_HEX = '#3B82F6';

export function normalizePrimaryHex(primaryColor, fallback = FALLBACK_HEX) {
  if (!primaryColor || typeof primaryColor !== 'string') return fallback;
  const t = primaryColor.trim();
  if (/^#[0-9A-Fa-f]{6}$/i.test(t)) return t;
  if (/^#[0-9A-Fa-f]{3}$/i.test(t)) {
    return (
      '#' +
      t
        .slice(1)
        .split('')
        .map((c) => c + c)
        .join('')
    );
  }
  return fallback;
}

export function hexToRgb(hex) {
  const h = normalizePrimaryHex(hex).slice(1);
  const full = h.length === 3 ? h.split('').map((c) => c + c).join('') : h;
  const n = parseInt(full, 16);
  return { r: (n >> 16) & 255, g: (n >> 8) & 255, b: n & 255 };
}

export function rgbaFromPrimary(primaryColor, alpha, fallbackHex = FALLBACK_HEX) {
  const { r, g, b } = hexToRgb(normalizePrimaryHex(primaryColor, fallbackHex));
  const a = Math.min(1, Math.max(0, alpha));
  return `rgba(${r},${g},${b},${a})`;
}

/** Clareia a cor para texto/accento legível sobre fundo escuro. */
export function lightenRgbString(primaryColor, amount = 0.5, fallbackHex = FALLBACK_HEX) {
  const { r, g, b } = hexToRgb(normalizePrimaryHex(primaryColor, fallbackHex));
  const t = Math.min(1, Math.max(0, amount));
  const lr = Math.round(r + (255 - r) * t);
  const lg = Math.round(g + (255 - g) * t);
  const lb = Math.round(b + (255 - b) * t);
  return `rgb(${lr},${lg},${lb})`;
}
